import { _ as __assign } from '../../chunks/bundle-j5GfJ6DZ.js';
import React__default from 'react';
import { useIIFE } from '@sendbird/uikit-tools';
import { l as isSendableMessage, g as getSuggestedReplies } from '../../chunks/bundle-EMEHizdG.js';
import { i as isDisabledBecauseFrozen, a as isDisabledBecauseMuted } from '../../chunks/bundle-44j0QAmj.js';
import { M as MessageView } from '../../chunks/bundle-DNqRGkzO.js';
import { FileViewer } from './FileViewer.js';
import { RemoveMessageModal } from './RemoveMessageModal.js';
import { T as ThreadReplySelectType } from '../../chunks/bundle-CPQL3IZE.js';
import { u as useGroupChannel } from '../../chunks/bundle-BykuFiQC.js';
import { u as useSendbird } from '../../chunks/bundle-DloqDvm2.js';
import '@sendbird/chat/groupChannel';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-Bzoj1u3h.js';
import '../../chunks/bundle-Cj_4CfJM.js';
import '../../chunks/bundle-RVsnVYbw.js';
import '../../chunks/bundle-C6g3HNED.js';
import '../../chunks/bundle-DNwRc4lK.js';
import '../../chunks/bundle-CnQtgeX8.js';
import '../../chunks/bundle-BSUtC3cw.js';
import '../../chunks/bundle-BjDPDV1u.js';
import '../../Message/hooks/useDirtyGetMentions.js';
import '../../ui/DateSeparator.js';
import '../../chunks/bundle-CyIWMcD_.js';
import '../../chunks/bundle-ZBp236Ey.js';
import '../../ui/MessageInput.js';
import '../../chunks/bundle-dyq0aH11.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '../../chunks/bundle-DRAooF75.js';
import 'dompurify';
import '../../chunks/bundle-CGAxlcUv.js';
import '../../chunks/bundle-xdZcjYxt.js';
import '../../chunks/bundle-DEv-umdP.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-idC_wVZi.js';
import '../../chunks/bundle-CSKhnQl7.js';
import '../../ui/MessageContent.js';
import '../../chunks/bundle-DHLFKbb3.js';
import '../../ui/Loader.js';
import '../../chunks/bundle-C7OVXMkh.js';
import '../../chunks/bundle-D82dEh7Z.js';
import '../../chunks/bundle-BMOZh9fu.js';
import '../../chunks/bundle-BB95aNhx.js';
import 'react-dom';
import '@sendbird/chat';
import '@sendbird/chat/openChannel';
import '../../ui/SortByRow.js';
import '../../chunks/bundle-B7LMd75S.js';
import '../../chunks/bundle-BC1GKYVu.js';
import '../../ui/MessageItemReactionMenu.js';
import '../../ui/ImageRenderer.js';
import '../../ui/ReactionButton.js';
import '../../chunks/bundle-CsFWohR-.js';
import '../../chunks/bundle-DvCKSiBl.js';
import '../../ui/EmojiReactions.js';
import '../../ui/ReactionBadge.js';
import '../../ui/BottomSheet.js';
import '../../hooks/useModal.js';
import '../../chunks/bundle-B4W1Qw_4.js';
import '../../ui/UserListItem.js';
import '../../chunks/bundle-S7XE7Lfi.js';
import '../../chunks/bundle-2OseAMr7.js';
import '../../chunks/bundle-BlgLvEI8.js';
import '../../ui/MutedAvatarOverlay.js';
import '../../ui/Checkbox.js';
import '../../ui/UserProfile.js';
import '../../sendbirdSelectors.js';
import '../../chunks/bundle-u2dy86rx.js';
import '../../ui/Tooltip.js';
import '../../ui/TooltipWrapper.js';
import '../../Message/context.js';
import '../../chunks/bundle-CHW7NXXK.js';
import '../../ui/AdminMessage.js';
import '../../ui/QuoteMessage.js';
import '../../chunks/bundle-7yeG72vW.js';
import '@sendbird/chat/message';
import '../../ui/MobileMenu.js';
import '../../ui/ThreadReplies.js';
import '../../chunks/bundle-CBOkD3as.js';
import '../../ui/OGMessageItemBody.js';
import '../../chunks/bundle-CclIyWE2.js';
import '../../ui/MentionLabel.js';
import '../../ui/LinkLabel.js';
import '../../ui/TextMessageItemBody.js';
import '../../ui/FileMessageItemBody.js';
import '../../ui/TextButton.js';
import '../../chunks/bundle-DWKpPzuv.js';
import '../../ui/FileViewer.js';
import '../../chunks/bundle-DTF9UGbO.js';
import '../../ui/VoiceMessageItemBody.js';
import '../../ui/ProgressBar.js';
import '../../VoicePlayer/useVoicePlayer.js';
import '../../chunks/bundle-0nLnxiJ2.js';
import '../../VoiceRecorder/context.js';
import '../../ui/PlaybackTime.js';
import '../../ui/ThumbnailMessageItemBody.js';
import '../../ui/UnknownMessageItemBody.js';
import '../../ui/TemplateMessageItemBody.js';
import '../../chunks/bundle-CNGGcC9m.js';
import '../../ui/FallbackTemplateMessageItemBody.tsx.js';
import '../../ui/LoadingTemplateMessageItemBody.tsx.js';
import '../../ui/MessageFeedbackFailedModal.js';
import '../../ui/FeedbackIconButton.js';
import '../../ui/MobileFeedbackMenu.js';
import '../../ui/MessageFeedbackModal.js';
import '../../ui/Input.js';
import '../../chunks/bundle-Bj2tVPd1.js';
import './SuggestedReplies.js';
import '../../chunks/bundle-B5EHFFGW.js';
import '../../chunks/bundle-BUqKgNmF.js';
import '../../chunks/bundle-gFEGYRmO.js';
import '../../chunks/bundle-B19WxiWc.js';
import '../../chunks/bundle-BSLHBsOu.js';
import '../../chunks/bundle--h0f5LUC.js';
import '../../chunks/bundle-CxpAk_cb.js';

var Message = function (props) {
    var state = useSendbird().state;
    var config = state.config, emojiManager = state.emojiManager;
    var _a = useGroupChannel(), _b = _a.state, loading = _b.loading, currentChannel = _b.currentChannel, animatedMessageId = _b.animatedMessageId, replyType = _b.replyType, threadReplySelectType = _b.threadReplySelectType, isReactionEnabled = _b.isReactionEnabled, nicknamesMap = _b.nicknamesMap, renderUserMentionItem = _b.renderUserMentionItem, filterEmojiCategoryIds = _b.filterEmojiCategoryIds, onQuoteMessageClick = _b.onQuoteMessageClick, onReplyInThreadClick = _b.onReplyInThreadClick, onMessageAnimated = _b.onMessageAnimated, onBeforeDownloadFileMessage = _b.onBeforeDownloadFileMessage, messages = _b.messages, _c = _a.actions, toggleReaction = _c.toggleReaction, setQuoteMessage = _c.setQuoteMessage, setAnimatedMessageId = _c.setAnimatedMessageId, scrollToMessage = _c.scrollToMessage, updateUserMessage = _c.updateUserMessage, sendUserMessage = _c.sendUserMessage, resendMessage = _c.resendMessage, deleteMessage = _c.deleteMessage;
    var message = props.message;
    var initialized = !loading && Boolean(currentChannel);
    var shouldRenderSuggestedReplies = useIIFE(function () {
        var _a = config.groupChannel, enableSuggestedReplies = _a.enableSuggestedReplies, showSuggestedRepliesFor = _a.showSuggestedRepliesFor;
        // Use `allMessages[allMessages.length - 1]` instead of `currentGroupChannel.lastMessage`
        // because lastMessage is not updated when **Bot** sends messages
        var lastMessageInView = messages[messages.length - 1];
        var hasUnsentMessage = isSendableMessage(lastMessageInView) && (lastMessageInView === null || lastMessageInView === void 0 ? void 0 : lastMessageInView.sendingStatus) !== 'succeeded';
        var showSuggestedReplies = showSuggestedRepliesFor === 'all_messages'
            ? true
            : message.messageId === (lastMessageInView === null || lastMessageInView === void 0 ? void 0 : lastMessageInView.messageId);
        return enableSuggestedReplies && getSuggestedReplies(message).length > 0 && !hasUnsentMessage && showSuggestedReplies;
    });
    return (React__default.createElement(MessageView, __assign({}, props, { channel: currentChannel, emojiContainer: emojiManager === null || emojiManager === void 0 ? void 0 : emojiManager.emojiContainer, editInputDisabled: !initialized
            || isDisabledBecauseFrozen(currentChannel !== null && currentChannel !== void 0 ? currentChannel : undefined)
            || isDisabledBecauseMuted(currentChannel !== null && currentChannel !== void 0 ? currentChannel : undefined)
            || !config.isOnline, shouldRenderSuggestedReplies: shouldRenderSuggestedReplies, isReactionEnabled: isReactionEnabled !== null && isReactionEnabled !== void 0 ? isReactionEnabled : false, replyType: replyType !== null && replyType !== void 0 ? replyType : 'NONE', threadReplySelectType: threadReplySelectType !== null && threadReplySelectType !== void 0 ? threadReplySelectType : ThreadReplySelectType.PARENT, nicknamesMap: nicknamesMap, renderUserMentionItem: renderUserMentionItem, filterEmojiCategoryIds: filterEmojiCategoryIds, scrollToMessage: scrollToMessage, toggleReaction: toggleReaction, setQuoteMessage: setQuoteMessage, onQuoteMessageClick: onQuoteMessageClick, onReplyInThreadClick: onReplyInThreadClick, sendUserMessage: sendUserMessage, updateUserMessage: updateUserMessage, resendMessage: resendMessage, deleteMessage: deleteMessage, animatedMessageId: animatedMessageId, setAnimatedMessageId: setAnimatedMessageId, onMessageAnimated: onMessageAnimated, renderFileViewer: function (props) { return React__default.createElement(FileViewer, __assign({}, props)); }, renderRemoveMessageModal: function (props) { return React__default.createElement(RemoveMessageModal, __assign({}, props)); }, usedInLegacy: false, onBeforeDownloadFileMessage: onBeforeDownloadFileMessage })));
};

export { Message, Message as default };
//# sourceMappingURL=Message.js.map
